import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';

import { Table, Text } from './styles';

const formatPercentage = (value) => `${_.round(value)}%`;

const CustomTable = (props) => {
  const { branches } = props;

  return (
    <Table basic="very">
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>
            <Text.Bold>Branch</Text.Bold>
          </Table.HeaderCell>
          <Table.HeaderCell>
            <Text.Bold>Visited First</Text.Bold>
          </Table.HeaderCell>
          <Table.HeaderCell>
            <Text.Bold>Visited during this task</Text.Bold>
          </Table.HeaderCell>
        </Table.Row>
      </Table.Header>

      <Table.Body>
        {!_.isEmpty(branches) && _.map(branches, (branch) => (
          <Table.Row>
            <Table.Cell>
              <Text>{branch.label}</Text>
            </Table.Cell>

            <Table.Cell>
              <Text>{formatPercentage(branch.firstClickPercentage)}</Text>
            </Table.Cell>
            <Table.Cell>
              <Text>{formatPercentage(branch.visitedPercentage)}</Text>
            </Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  );
};

CustomTable.propTypes = {
  branches: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.string,
      visitedPercentage: PropTypes.number,
      firstClickPercentage: PropTypes.number,
    }),
  ).isRequired,
};

export default CustomTable;
